import ExpenseGroupCard from "./ExpenseGroupCard";
import useData from "./data";

export default function ExpenseGroupList() {
  const { expenseGroups } = useData();
  return (
    <div className="mt-4">
      <h5 className="mb-3 text-muted">Expense Groups</h5>

      {expenseGroups.map((expenseGroup) => (
        <ExpenseGroupCard key={expenseGroup.id} expenseGroup={expenseGroup} />
      ))}

      {expenseGroups.length === 0 && (
        <div className="text-center">
          <p>No expense groups found</p>
        </div>
      )}
    </div>
  );
}
